module.exports = __webpack_public_path__ + "img/ricardo.a65b7a8e.png";